import React, { useEffect, useState } from 'react';
import BreadcrumbBack from '../../../components/breadcrumb/BreadcrumbBack';
import CustomButton from '../../../components/button/CustomButton';
import Models from '../../../components/models/Models';
import AdminCourseCategory from './courseCategory/AdminCourseCategory';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import PaginationDataGrid from '../../../components/tables/PaginationDataGrid';
import { Helmet } from 'react-helmet-async';
import { randomNumber } from '../../../helpers/helpers';

export default function AdminCourses() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [courseFilter, setCourseFilter] = useState<any>("null")
  const [courseCategory, setCourseCategory] = useState<any>("null");
  const [searchParams] = useSearchParams()
  const [refresh, setRefresh] = useState<any>();
  let pathlength = location.pathname.split('/').length;
  let coursMasterName = location.pathname.split('/')[pathlength - 1];
  useEffect(()=>{
      if(searchParams.get('filter')){
        setCourseFilter(searchParams.get('filter'))
      }else{
        setCourseFilter("null")
      }
       if(searchParams.get('category')){
        setCourseCategory(searchParams.get('category'))
      }else{
        setCourseCategory("null")
      }
  },[searchParams])
  return (
    <>
      <Helmet>
        <title>{`Course Master | ${window.location.hostname}`}</title>
      </Helmet>
      <BreadcrumbBack title={`${courseFilter !== "null"  ?  `${courseFilter}'s Courses` : `All Courses`}`}>
        <CustomButton
                onClick={() => navigate('/admin/courses/master/coupon/master')}
                bg="bg-purple-700"
                title="Coupon Master"
                icon={true}
                iconName="bookMark"
              />
        <CustomButton
          onClick={() =>
            navigate(`/admin/courses/master/${courseFilter}/create`)
          }
          bg="bg-purple-800"
          title="Create Course"
          icon={true}
          iconName="create"
        />
        <CustomButton
          onClick={() => navigate(`/admin/courses/master`)}
          title="Create Menu"
          icon={true}
          iconName="create"
        />
      </BreadcrumbBack>

      <div className="my-2">
      <PaginationDataGrid dataId={courseCategory} id={courseFilter} name="adminCourses" />
      </div>
    </>
  );
}
